import { TILE_TYPE } from '@shared/constants';

const filterCampaignPropertiesByOrigin = (campaignProperties, originCode) => {
  if (!originCode) {
    return campaignProperties;
  }

  return campaignProperties.filter((campaignProperty) => {
    switch (campaignProperty.type) {
      case TILE_TYPE.PROCURED_OFFER:
        return campaignProperty.procuredOffer?.brands.includes(
          'qantas-holidays',
        )
          ? campaignProperty.procuredOffer?.origins?.some(
              (o) => o === originCode,
            )
          : campaignProperty;

      case TILE_TYPE.CROSS_SELL_BANNER:
        return true;

      default:
        return false;
    }
  });
};

export default filterCampaignPropertiesByOrigin;
